import { render, staticRenderFns } from "./cz-record.vue?vue&type=template&id=c1a6c3c6&"
import script from "./cz-record.vue?vue&type=script&lang=js&"
export * from "./cz-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports